import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { createStore, StateCreator } from 'zustand/vanilla';
import { ZustandAdapter } from './zustand-adapter';
import type { DetalleAvancePlanNegocio } from '../shared/services/negocio.service';

function clampPct(raw: unknown): number {
  const n = typeof raw === 'number' ? raw : Number(raw);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, Math.round(n)));
}

export interface GestionPlanAvanceState {
  /** % avance general alineado a `detalle_avance.total` (listado, GET productor, GET `.../avance`). */
  avanceGeneral: number;
  sincronizarDesdeDetalleAvance: (det: DetalleAvancePlanNegocio | null | undefined) => void;
  setAvanceGeneral: (pct: number) => void;
  reset: () => void;
}

const createGestionPlanAvanceStore: StateCreator<GestionPlanAvanceState> = (set) => ({
  avanceGeneral: 0,
  sincronizarDesdeDetalleAvance: (det) => {
    const t = det?.total;
    set({ avanceGeneral: clampPct(t ?? 0) });
  },
  setAvanceGeneral: (pct) => set({ avanceGeneral: clampPct(pct) }),
  reset: () => set({ avanceGeneral: 0 }),
});

/**
 * Store Zustand: % de avance general del plan del productor activo en gestión.
 */
@Injectable({ providedIn: 'root' })
export class GestionPlanAvanceStore extends ZustandAdapter<GestionPlanAvanceState> {
  constructor() {
    super(createStore<GestionPlanAvanceState>(createGestionPlanAvanceStore));
  }

  get avanceGeneral$(): Observable<number> {
    return this.select((s) => s.avanceGeneral);
  }

  sincronizarDesdeDetalleAvance(det: DetalleAvancePlanNegocio | null | undefined): void {
    this.getStore().getState().sincronizarDesdeDetalleAvance(det);
  }

  setAvanceGeneral(pct: number): void {
    this.getStore().getState().setAvanceGeneral(pct);
  }

  reset(): void {
    this.getStore().getState().reset();
  }
}
